/**
 * Gallery: lightbox only (scroll reveal is global `parksystem-reveal.js`).
 */
(function () {
	'use strict';

	const BLOCK = '.wp-block-parksystem-gallery';
	const CARD = '.ps-gallery__card';
	const OPEN_CLASS = 'is-ps-lightbox-open';

	/**
	 * @param {HTMLElement} grid
	 */
	function bindGrid(grid) {
		const root = grid.closest(BLOCK);
		if (!root) {
			return;
		}

		let overlay = null;
		let imgEl = null;
		let closeBtn = null;

		function close() {
			if (overlay && overlay.parentNode) {
				overlay.parentNode.removeChild(overlay);
			}
			overlay = null;
			imgEl = null;
			closeBtn = null;
			document.body.classList.remove(OPEN_CLASS);
			document.removeEventListener('keydown', onKey);
		}

		function onKey(e) {
			if (e.key === 'Escape') {
				close();
			}
		}

		function openLightbox(url, alt) {
			if (!url) {
				return;
			}

			close();

			overlay = document.createElement('div');
			overlay.className = 'ps-gallery-lightbox';
			overlay.setAttribute('role', 'dialog');
			overlay.setAttribute('aria-modal', 'true');

			closeBtn = document.createElement('button');
			closeBtn.type = 'button';
			closeBtn.className = 'ps-gallery-lightbox__close';
			closeBtn.setAttribute('aria-label', 'Zamknij');
			closeBtn.innerHTML =
				'<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

			imgEl = document.createElement('img');
			imgEl.className = 'ps-gallery-lightbox__img';
			imgEl.src = url;
			imgEl.alt = alt || '';

			overlay.appendChild(closeBtn);
			overlay.appendChild(imgEl);
			document.body.appendChild(overlay);
			document.body.classList.add(OPEN_CLASS);
			document.addEventListener('keydown', onKey);

			closeBtn.addEventListener('click', (e) => {
				e.stopPropagation();
				close();
			});
			overlay.addEventListener('click', close);
			imgEl.addEventListener('click', (e) => e.stopPropagation());
		}

		grid.querySelectorAll(CARD).forEach((card) => {
			card.addEventListener('click', () => {
				const url = card.getAttribute('data-ps-gallery-url');
				const thumb = card.querySelector('.ps-gallery__card-image img');
				const alt = (thumb && thumb.getAttribute('alt')) || '';
				openLightbox(url, alt);
			});
		});
	}

	function init() {
		document.querySelectorAll(BLOCK).forEach((root) => {
			const grid = root.querySelector('.ps-gallery__grid');
			if (grid) {
				bindGrid(grid);
			}
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
